import { ArchiveState } from "@/store/Crud/functions/archived/State";

export function SET_ARCHIVE_SUCCESS(state: ArchiveState, archiveSuccess: any) {
  state.archiveSuccess = archiveSuccess;
}
